import { Component, HostBinding, inject, input, linkedSignal } from '@angular/core';
import { AppState } from '@services/core/app-state';
import { cssValue } from '@helpers';
@Component({
  selector: 'app-main-container',
  standalone: true,
  imports: [],
  templateUrl: './main-container.html',
  styles: `
    :host {
      height: 100%;
      display: flex;
    }
  `,
})
export class MainContainer {
  // Dependencias
  private readonly appState = inject(AppState);

  // Inputs
  $paddingTop = input<string>('12px', { alias: 'paddingTop' });
  $paddingRight = input<string>('36px', { alias: 'paddingRight' });
  $paddingBottom = input<string>('28px', { alias: 'paddingBottom' });
  $_paddingLeft = input<string>(undefined, { alias: 'paddingLeft' });
  $paddingLeft = linkedSignal(this.$_paddingLeft);

  // Bindings
  @HostBinding('style.paddingTop')
  get hostPaddingTop(): string | undefined { return cssValue(this.$paddingTop()); }

  @HostBinding('style.paddingRight')
  get hostPaddingRight(): string | undefined { return cssValue(this.$paddingRight()); }

  @HostBinding('style.paddingBottom')
  get hostPaddingBottom(): string | undefined { return cssValue(this.$paddingBottom()); }

  @HostBinding('style.paddingLeft')
  get hostPaddingLeft(): string | undefined {
    let value = this.$paddingLeft();
    if (value === undefined)
      value = !this.appState.$asideText() && !this.appState.$asideLabel() && !this.appState.$asideLogo() ? '36px' : '80px';
    return cssValue(value);
  }
}
